import { useHistory } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

/**
 * Generic utilty hook that will handles all search params updates for the accommodations console
 */
export const useUpdateAccommodationsConsoleSearchParams = () => {
  const history = useHistory();
  const applyAccommodationConsoleSearchParamsToUrl = useEventCallback(
    (args: { searchParams: Record<string, string | null>; actionType: 'replace' | 'push'; locationHash?: string }) => {
      const { searchParams: searchParamOverrides, actionType, locationHash } = args;
      // `history.location` rather than `useLocation()`: the hook's value only catches up on the next
      // render, so a second write in the same handler rebuilt from the pre-write search string and
      // silently undid the first — which is why "Show nearest hotels" did nothing.
      const location = history.location;
      const params = new URLSearchParams(location.search);

      Object.entries(searchParamOverrides).forEach(([key, value]) => {
        if (value === null || value === '') {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });

      history[actionType]?.({
        pathname: location.pathname,
        // Falling back to the current hash: history uses exactly what it is given, so a caller that
        // only cares about query params would otherwise wipe the hash.
        hash: locationHash ?? location.hash,
        search: params.toString(),
      });
    },
  );

  return {
    applyAccommodationConsoleSearchParamsToUrl,
  };
};
